import React from 'react'
import './caption.css'
import line from '../images/line.svg'

 

const Caption = props => (
    <div className="caption">
        <img src={line} />
        <p>{props.captiontext}</p>
    </div>

)

export default Caption